import { createEntityAdapter } from '@ngrx/entity';
import { Announcements } from '@app/core/async-services/http/versioned/interfaces';

export const departments = createEntityAdapter<Announcements.Department>({
  selectId: ({ departmentID }) => departmentID,
  sortComparer: (a, b) => a.departName.localeCompare(b.departName)
});

export const hotels = createEntityAdapter<Announcements.Hotel>({
  selectId: ({ entID }) => entID,
  sortComparer: (a, b) => a.entName.localeCompare(b.entName)
});

export const managers = createEntityAdapter<Announcements.Manager>({
  selectId: ({ webUserId }) => webUserId
});
